import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useI18nContext } from '../../contexts/I18nContext';

/**
 * Custom hook that wraps react-i18next useTranslation
 * Provides type-safe translation functions and language management
 */
export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const { currentLanguage, changeLanguage, isLoading } = useI18nContext();

  /**
   * Check if the current language is Spanish
   */
  const isSpanish = currentLanguage === 'es';

  /**
   * Check if the current language is English
   */
  const isEnglish = currentLanguage === 'en';

  /**
   * Get available languages
   */
  const availableLanguages = [
    { code: 'es' as const, name: t('language.spanish'), flag: '🇨🇱' },
    { code: 'en' as const, name: t('language.english'), flag: '🇺🇸' },
  ];

  return {
    t,
    changeLanguage,
    currentLanguage,
    isSpanish,
    isEnglish,
    availableLanguages,
    isLoading,
    i18n,
  };
};

export default useTranslation;